export default "__VITE_ASSET__5blPi4VT__"